// Generated by GitHub Copilot
import { Api } from '#core/api/Api.ts'
import {
  PushSubscriptionListResponse,
  PushSubscriptionResponse,
  VapidPublicKeyResponse,
} from '#core/entities/operations/notifications/NotificationPushSubscription.ts'


export interface CreateNotificationRegistrationPayload extends Record<string, unknown> {
  endpoint: string,
  p256dh: string,
  auth: string,
}

/** API client for the `/operations/push-subscriptions` endpoints. */
export default class NotificationPushSubscriptionApi extends Api<NotificationPushSubscriptionApi> {
  private static readonly path = 'operations/push-subscriptions'

  constructor() {
    super()
  }

  /** Fetch the server's VAPID public key for Web Push subscription. */
  public async getVapidPublicKey(): Promise<VapidPublicKeyResponse | null> {
    return this.get<VapidPublicKeyResponse>(
      NotificationPushSubscriptionApi.path + '/vapid-public-key',
      undefined,
      VapidPublicKeyResponse,
    )
  }

  /** List all push subscriptions for the authenticated user. */
  public async listPushSubscriptions(): Promise<PushSubscriptionListResponse | null> {
    return this.get<PushSubscriptionListResponse>(
      NotificationPushSubscriptionApi.path,
      undefined,
      PushSubscriptionListResponse,
    )
  }

  /** Register a web push subscription (idempotent). */
  public async createPushSubscription(
    payload: CreateNotificationRegistrationPayload,
  ): Promise<PushSubscriptionResponse | null> {
    return this.post<PushSubscriptionResponse>(
      NotificationPushSubscriptionApi.path,
      payload,
      PushSubscriptionResponse,
    )
  }

  /** Remove a push subscription by its endpoint URL. */
  public async deletePushSubscription(endpoint: string): Promise<void> {
    await this.delete<never>(NotificationPushSubscriptionApi.path, undefined, { endpoint })
  }
}
